import { render } from "./EquivalenceTable.vue?vue&type=template&id=22bf3eb4"
import script from "./EquivalenceTable.vue?vue&type=script&lang=js"
export * from "./EquivalenceTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__